import { configureStore } from "@reduxjs/toolkit";
import loginUserReducer from "reducer/login/login-user";

export const store = configureStore({
  reducer: {
    loginUser: loginUserReducer,
  },
});
